import React, { Component } from 'react';
import './TransportStep.css';
import InputField from '../../../../components/Input-field/InputField';
import VinCodeInput from '../../../../components/VinCodeInput/VinCodeInput';
import { Field, reduxForm, change, formValueSelector } from 'redux-form';
import InputSelect from '../../../../components/Input-select/InputSelect';
import api from '../../../../api/index';
import * as moment from 'moment';
import { mapToOptions } from '../../../../utils/index';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import SelectCarCard from '../../../../components/Select-car-card/SelectCarCard';
import Mercedes from '../../../../assets/images/Mercedes.png';
import Audi from '../../../../assets/images/audi-image.png';
import Opell from '../../../../assets/images/opel_image.png';
import Nissan from '../../../../assets/images/nissan-image.png';
import Toyota from '../../../../assets/images/toyota-image.png';
import SelectedCarCardMobile from '../../../../components/Select-Car-Card-Mobile/SelectCarCardMobile';
import SelectedCarCardSmMobile from '../../../../components/Select-Car-Card-Sm-Mobile/SelectCarCardSmMobile'
import PolicyRegScrollbar from '../../../../components/PolicyRegScrollbar/PolicyRegScrollbar'
import ReactTooltip from 'react-tooltip'
const validate = values => {
	const errors = {};
	if (!values.vehicleManufacturerId) {
		errors.vehicleManufacturerId = 'chooseField';
	}

	if (!(values.chassisNumber || values.vinCode)) {
		errors.vinCode = 'fillInput';
	}

	if (!(values.chassisNumber || values.vinCode)) {
		errors.chassisNumber = 'fillInput';
	}

	if (values.chassisNumber && (/[^a-z0-9]/i.test(values.chassisNumber))) {
		errors.chassisNumber = 'inputInEnglish';
	}

	// if (values.chassisNumber && values.chassisNumber !== values.chassisNumber.toUpperCase()){
	//   errors.chassisNumber = 'InputOnlyUppercase';
	// }

	if (values.chassisNumber && values.chassisNumber.length > 20) {
		errors.chassisNumber = 'max20Symbols';
	}

	if (values.vinCode && (/[^a-z0-9]/i.test(values.vinCode))) {
		errors.vinCode = 'inputInEnglish';
	}

	// if (values.vinCode && values.vinCode !== values.vinCode.toUpperCase()){
	//     errors.vinCode = 'InputOnlyUppercase';
	//   } 

	// if (values.vinCode && values.vinCode.length > 24) {
	//     errors.vinCode = 'max20Symbols';
	// }

	if (values.vinCode && values.vinCode.length < 17) {
		errors.vinCode = 'min17Symbols';
	}

	if (values.vinCode && /[^a-z0-9]/i.test(values.vinCode)) {
		errors.vinCode = 'inputInEnglish';
	}

	// if (values.vinCode && values.vinCode.includes("O") ){
	//   errors.vinCode = 'inputInEnglish';
	// } 

	// if (values.vinCode && values.vinCode.includes("I") ){
	//   errors.vinCode = 'inputInEnglish';
	// } 

	if (!values.vehicleManufacturerNumber) {
		errors.vehicleManufacturerNumber = 'fillInput';
	}

	if (!values.vehicleRegistrationNumber) {
		errors.vehicleRegistrationNumber = 'fillInput';
	}

	if (values.vehicleRegistrationNumber && values.vehicleRegistrationNumber.length > 15) {
		errors.vehicleRegistrationNumber = 'max15Symbols';
	}

	// if (values.vehicleRegistrationNumber && values.vehicleRegistrationNumber !== values.vehicleRegistrationNumber.toUpperCase()){
	//   errors.vehicleRegistrationNumber = 'InputOnlyUppercase';
	// } 

	if (values.vehicleRegistrationNumber && /[^a-z0-9]/i.test(values.vehicleRegistrationNumber)) {
		errors.vehicleRegistrationNumber = 'inputInEnglish';
	}



	if (!values.vehicleModelId) {
		errors.vehicleModelId = 'chooseField';
	}

	return errors;
};

class TransportStep extends Component {
	constructor() {
		super();
		this.state = {
			categories: [],
			date: moment(),
			periods: [],
			manufacturers: [],
			selectedManufacturer: '',
			models: [],
			products: [],
			vinCodeDisabled: false,
			chassisNumber: false,
			vehicleIdentificationType: [],
			vehicleManufacturerRef: null,
			vehicleModelRef: null
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		api.vehicle.manufacturers().then(({ data }) => {
			this.setState({
				manufacturers: mapToOptions(data),
			});
		});
		if (this.props.vehicleManufacturerNumber) {
			api.vehicle
				.models(this.props.vehicleManufacturerNumber)
				.then(({ data }) => {
					this.setState({
						models: mapToOptions(data),
					});
				});
		}

		this.setState({
			vehicleIdentificationType: [
				{ label: this.props.translate('vinCode'), value: 1 },
				{ label: this.props.translate('chassisNumber'), value: 2 },
			],
		});
	}
	componentDidUpdate() { }

	onChangeManufacture = value => {
		api.vehicle.models(value).then(({ data }) => {
			this.setState({
				models: mapToOptions(data),
			});
		});

		this.state.manufacturers.forEach(item => {
			if (item.value === value) {
				this.props.dispatch(
					change('CreatePolicyForm', 'vehicleManufacturerName', item.label)
				);
				this.props.dispatch(
					change('CreatePolicyForm', 'vehicleManufacturerNumber', item.value)
				);
				this.setState({
					selectedManufacturer: item.label,
				});
			}
		});
	};
	// onStartDateChange =(event,value)=>{
	//     if(this.props.issueDateDiff!==1){
	//         this.props.dispatch(change('CreatePolicyForm', 'endDate', moment(value).add((this.props.issueDateDiff - 1 ),'d').format('DD/MM/YYYY')))
	//     }
	//     else {
	//         this.props.dispatch(change('CreatePolicyForm', 'endDate', moment(value).add((this.props.issueDateDiff),'y').format('DD/MM/YYYY')))
	//     }
	// }
	//     onCategoryChange =(event,value)=>{
	//
	//         this.props.dispatch(change('CreatePolicyForm', 'endDate', ''));
	//         this.props.dispatch(change('CreatePolicyForm', 'premium', ''));
	//         this.props.categories.forEach((item)=>{
	//             if(item.id===value){
	//                 this.props.dispatch(change('CreatePolicyForm', 'vehicleCategoryName', item.name));
	//                 this.setState({
	//                     products:item.products
	//                 })
	//             }
	//         })
	//     }
	//     onIssueDate =(event,value) =>{
	//         this.state.products.forEach((item)=>{
	//             if(item.productId === value){
	//                 this.props.dispatch(change('CreatePolicyForm', 'premium',item.price))
	//             }
	//         })
	//         this.state.periods.forEach((item)=>{
	//             if(value === item.value){
	//                 if(parseInt(item.label)!==1){
	//                     this.props.dispatch(change('CreatePolicyForm', 'endDate', moment(this.props.startDate).add((parseInt(item.label)-1),'d').format('DD/MM/YYYY')))
	//                 }
	//                 else {
	//                     this.props.dispatch(change('CreatePolicyForm', 'endDate', moment(this.props.startDate).add((parseInt(item.label)),'y').format('DD/MM/YYYY')))
	//                 }
	//             }
	//         })
	//     }
	render() {
		const { handleSubmit, translate, previousPage } = this.props;
		return (
			<div className="policy-registration-container">
				<div className="policy-create-cards-wrapper">
					<div className="policy-create-card-manufacturer">
						<SelectedCarCardMobile />
						{/* <div className="manufacturer">
              <label className="manufacturer-label">{translate('selectManufacturer')}</label>
              <div className="manufacturer-item-select">
                <Field
                    id={500}
                    name="vehicleManufacturerId"
                    labelName={'space'}
                    options={this.state.manufacturers}
                    component={InputSelect}
                    onChange={(e, value) => {
                        this.onChangeManufacture(value);
                    }}
                />
              </div>
              <div className="selected-car">{this.props.vehicleManufacturerName}</div>
            </div> */}
					</div>
					<div className="policy-create-card" id="policy-create-card">
						<PolicyRegScrollbar numb={2} />
						<SelectedCarCardSmMobile />

						<form onSubmit={handleSubmit}>
							<div>
								<div className="collapsible">

									<div className="collapse-item">
										<div>
											<div className="manufacturer-item-select">
												<a data-for="vhManId" data-tip ref={ref => this.vehicleManufacturerRef = ref}>
													<Field
														id={500}
														name="vehicleManufacturerId"
														labelName={'selectManufacturer'}
														options={this.state.manufacturers}
														component={InputSelect}
														onChange={(e, value) => {
															this.onChangeManufacture(value);
															ReactTooltip.hide(this.vehicleManufacturerRef)
														}}
													/>
												</a>
											</div>
											<ReactTooltip id='vhManId' type="success" effect='solid' place="right" >
												<div className="tooltip">
													<div className="category-description-text">
														<p>{translate('selectManufacturerOther')}</p>
													</div>
												</div>
											</ReactTooltip>
											<a data-for="vhModId" data-tip ref={ref => this.vehicleModelRef = ref}>
												<Field
													name="vehicleModelId"
													labelName={'vehicleModelId'}
													options={this.state.models}
													onChange={(event, value) => {
														this.state.models.forEach(item => {
															if (item.value === value) {
																this.props.dispatch(
																	change(
																		'CreatePolicyForm',
																		'vehicleModelName',
																		item.label
																	)
																);
															}
														});
														ReactTooltip.hide(this.vehicleModelRef)
													}}
													component={InputSelect}
													id={200}
													type="text"
												/>
											</a>
											<ReactTooltip id='vhModId' type="success" effect='solid' place="right" >
												<div className="tooltip">
													<div className="category-description-text">
														<p>{translate('selectModelOther')}</p>
													</div>
												</div>
											</ReactTooltip>
											<Field
												name="vehicleRegistrationNumber"
												labelName={'vehicleRegistrationNumber'}
												component={InputField}
												id={3}
												placeholder={''}
												type="text"
												uppercase={true}
											/>
										</div>
										<div>
											<div className="vehicle-identification">
												<div className="input-radio-group">
													<div className="input-radio">
														<label className="input-radio-label">
															<Field
																name="vehicleIdentificationType"
																value="1"
																component="input"
																type="radio"
																onChange={() => {
																	this.props.dispatch(change('CreatePolicyForm', 'vinCode', ''));
																	this.props.dispatch(change('CreatePolicyForm', 'chassisNumber', ''));
																}}
															/>
															<span className="input-radio-circle" />
															<span className="input-radio-text">
																{translate('vinCode')}
															</span>
														</label>
													</div>
													<div className="input-radio">
														<label className="input-radio-label">
															<Field
																name="vehicleIdentificationType"
																value="2"
																component="input"
																type="radio"
																onChange={() => {
																	this.props.dispatch(change('CreatePolicyForm', 'vinCode', ''));
																	this.props.dispatch(change('CreatePolicyForm', 'chassisNumber', ''));
																}}
															/>
															<span className="input-radio-circle" />
															<span className="input-radio-text">
																{translate('chassisNumber')}
															</span>
														</label>
													</div>
												</div>
											</div>
											{/*<Field name="vehicleIdentificationType" labelName={"space"}  options={this.state.vehicleIdentificationType} component={InputSelect}   id={198}  type="text"/>*/}
											{this.props.vehicleIdentificationType === '1' && (
												<Field
													name="vinCode"
													labelName={'vinCode'}
													component={VinCodeInput}
													id={1}
													placeholder={''}
													type="text"
													uppercase={true}
												/>
											)}

											{this.props.vehicleIdentificationType === '2' && (
												<Field
													name="chassisNumber"
													labelName={'chassisNumber'}
													component={InputField}
													id={2}
													placeholder={''}
													type="text"
													uppercase={true}
												/>
											)}
										</div>
									</div>
								</div>
							</div>
							<div className="container step-btn-content transport-step-btn-content-mob">
								<button className="back-btn" onClick={previousPage}>
									{translate('back')}
								</button>
								<button className="next-btn" type="submit">
									{translate('next')}
								</button>
							</div>
						</form>
					</div>
				</div>
				<SelectCarCard />
			</div>
		);
	}
}
TransportStep = reduxForm({
	validate,
	forceUnregisterOnUnmount: true,
	destroyOnUnmount: false,
	form: 'CreatePolicyForm', // a unique identifier for this form
})(TransportStep);
const selector = formValueSelector('CreatePolicyForm');

const mapStateToProps = state => {
	const vehicleCategoryId = selector(state, 'vehicleCategoryId');
	const issueDate = selector(state, 'issueDate');
	const startDate = selector(state, 'startDate');
	const issueDateDiff = selector(state, 'issueDateDiff');
	const vehicleManufacturerName = selector(state, 'vehicleManufacturerName');
	const vehicleManufacturerNumber = selector(
		state,
		'vehicleManufacturerNumber'
	);
	const vehicleIdentificationType = selector(
		state,
		'vehicleIdentificationType'
	);
	return {
		vehicleCategoryId,
		issueDate,
		startDate,
		issueDateDiff,
		vehicleManufacturerName,
		vehicleManufacturerNumber,
		vehicleIdentificationType,
		translate: getTranslate(state.locale),
	};
};

export default connect(mapStateToProps)(TransportStep);



// WEBPACK FOOTER //
// ./src/pages/PoliciesCreatePage/steps/TransportStep/TransportStep.js